import request from '@/utils/request';

// 基础_行情报价_大数据查询品类行情
export async function selBigdataPriceOfferByForm(params) {
  return request.post('/openapi/basic/priceOffer/selBigdataPriceOfferByForm/manage', { ...params });
}
// 数据服务_进场管理_车辆管理_根据条件查询车辆来源目的地统计货品数量
export async function selVehicleListByParam(params) {
  return request.post('/openapi/dmp/vehicleDm/selVehicleListByParam/manage', { ...params });
}
// 交易服务_进场管理_进场预约_根据管理用户boId查询货品现存数量
export async function selExistingCaregoNumByRelBoId(params) {
  return request.post('/openapi/trading/vehicle/selExistingCaregoNumByRelBoId/manage', { ...params });
}
// 交易服务_订单管理_订单_统计未付款的草料订单
export async function counUnpaidFodderOrderNumByParam(params) {
  return request.post('/openapi/trading/order/counUnpaidFodderOrderNumByParam/manage', { ...params });
}
// 交易_进场管理_园区现存品类数据
export async function countNumGroupByCate(params) {
  return request.post('/openapi/trading/vehicle/countNumGroupByCate/manage', { ...params });
}
// 交易_进场管理_进场车辆总数_出场车辆总数_今日进场车辆数_今日出场车辆数
export async function countNumByType(params) {
  return request.post('/openapi/trading/vehicle/countNumByType/manage', { ...params });
}
// 大数据_订单_查询实时交易公告板
export async function selTradingBulletinBoard(params) {
  return request.post('/openapi/dmp/orderDm/selTradingBulletinBoard/manage', { ...params });
}
// 大数据_订单_园区牲畜的累计交易额_累计交易数量_今日交易额_今日交易数量
export async function selTradingData(params) {
  return request.post('/openapi/dmp/orderDm/selTradingData/manage', { ...params });
}
// 大数据_订单_分类平台总交易额
export async function selPaidMoneyGroupByCategory(params) {
  return request.post('/openapi/dmp/orderDm/selPaidMoneyGroupByCategory/manage', { ...params });
}
// （优质商家）交易服务_店铺管理_店铺_查询数据大屏排行榜根据顺序字段
export async function selShopListBySortDesc(params) {
  return request.post('/openapi/trading/shopInfo/selShopListBySortDesc/manage', { ...params });
}
// （金牌经济人）数据服务_店铺_店铺管理_根据条件查询店铺标签排行榜
export async function selShopTageRankingByParam(params) {
  return request.post('/openapi/dmp/shopInfoDm/selShopTageRankingByParam/manage', { ...params });
}
// 基础_行情报价_查询当日行情区间
export async function selTodayPriceOffer(params) {
  return request.post('/openapi/basic/priceOffer/selTodayPriceOffer/manage', { ...params });
}
// 草料价格公告板_查询价格公告板
export async function selPriceOfferByListByPage(params) {
  return request.post('/openapi/basic/priceOffer/selPriceOfferByListByPage/manageNoLogin', {
    ...params,
  });
}
// 交易_订单_查询品类均价
export async function selAvgPriceByManuId(params) {
  return request.post('/openapi/trading/order/selAvgPriceByManuId/manage', {
    ...params,
  });
}
